export const maxBy = <T>(items: Array<T>, projection: (x: T) => any): T =>
	items.reduce((a: any, c: T) => (a === undefined || projection(c) > projection(a) ? c : a), undefined);
